import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Fare Page")
    .schemaType("farePage")
    .child(S.documentTypeList("farePage"));
